module.exports = __webpack_public_path__ + "media/images/flags/jm-6bb96bbc99218d9f84f7edcf8012c77b.svg";